import { Hero, StyledLink } from "./Home.styled";

export default function Home() {
  return (
    <Hero>
      <StyledLink to="/catalog">Herous</StyledLink>
    </Hero>
  );
}
